import React from "react";
import { Link } from "react-router-dom";
import clickNidoLogo from "../images/stage_01/ClickNido_Logo.png";

const serviceLinks = [
  { label: "Home Services", path: "/services/instant-home-services" },
  { label: "Technical Services", path: "/services/technical-services" },
  { label: "Caretaker Services", path: "/services/caretaker-services" },
  { label: "Outdoor Services", path: "/services/outdoor-services" },
  { label: "Transport Services", path: "/services/transport-services" },
  { label: "Special Services", path: "/services/special-services" },
  { label: "All Services", path: "/services/all-services" }
];

const topServiceLinks = [
  { label: "Cleaning", path: "/services/instant-home-services" },
  { label: "Electrician", path: "/schedule-booking/technical" },
  { label: "Caretaker Services", path: "/services/caretaker-services" },
  { label: "Deep Cleaning", path: "/service/special-service/deep-cleaning" }
];

const companyLinks = [
  { label: "About Us", path: "/about-us" },
  { label: "How It Works", path: "/how-it-works" },
  // Downloads the Partner App instead of navigating to a page — same as the
  // header's "Become a Professional" link (Header.js) and for the same
  // reason: /become-a-professional has no route registered in App.js.
  { label: "Become a Professional", path: "https://play.google.com", external: true },
  // /careers has no route registered in App.js — send interested applicants
  // to Contact Us instead of a dead link.
  { label: "Careers", path: "/contact-us" },
  { label: "Blog", path: "/blog" },
  { label: "Terms & Conditions", path: "/terms-conditions" },
  { label: "Privacy Policy", path: "/privacy-policy" }
];

const supportLinks = [
  { label: "Contact Us", path: "/contact-us" },
  { label: "Track Order", path: "/track-order" },
  { label: "Cancellation Policy", path: "/cancellation-policy" },
  { label: "Refund Policy", path: "/refund-policy" },
  { label: "FAQ", path: "/faq" }
];

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.topGrid}>
        <div style={styles.brandCol}>
          <Link to="/" style={styles.brandWrap}>
            <img src={clickNidoLogo} alt="ClickNido" style={styles.logoImg} />
          </Link>

          <p style={styles.brandDesc}>
            Your one-stop solution to book trusted professionals for all your
            home and business needs.
          </p>

          <div style={styles.socialWrap}>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon} className="cn-footer-social">f</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon} className="cn-footer-social">x</a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon} className="cn-footer-social">ig</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon} className="cn-footer-social">in</a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={styles.socialIcon} className="cn-footer-social">yt</a>
          </div>

          <div style={styles.downloadCard}>
            <h4 style={styles.cardTitle}>Download Our App</h4>
            <p style={styles.cardText}>Book services on the go</p>

            <div style={styles.appButtons}>
              <a
                href="https://play.google.com"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.storeBtn}
              >
                Google Play
              </a>
            </div>
          </div>
        </div>

        <div style={styles.linkCol}>
          <h3 style={styles.columnTitle}>Our Services</h3>
          <div style={styles.linkList}>
            {serviceLinks.map((item, index) => (
              <Link key={index} to={item.path} style={styles.footerLink} className="cn-footer-link">
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div style={styles.linkCol}>
          <h3 style={styles.columnTitle}>Top Services</h3>
          <div style={styles.linkList}>
            {topServiceLinks.map((item, index) => (
              <Link key={index} to={item.path} style={styles.footerLink} className="cn-footer-link">
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div style={styles.linkCol}>
          <h3 style={styles.columnTitle}>Company</h3>
          <div style={styles.linkList}>
            {companyLinks.map((item, index) => (
              item.external ? (
                <a key={index} href={item.path} target="_blank" rel="noopener noreferrer" style={styles.footerLink} className="cn-footer-link">
                  {item.label}
                </a>
              ) : (
                <Link key={index} to={item.path} style={styles.footerLink} className="cn-footer-link">
                  {item.label}
                </Link>
              )
            ))}
          </div>
        </div>

        <div style={styles.linkCol}>
          <h3 style={styles.columnTitle}>Support</h3>
          <div style={styles.linkList}>
            {supportLinks.map((item, index) => (
              <Link key={index} to={item.path} style={styles.footerLink} className="cn-footer-link">
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div style={styles.contactCol}>
          <h3 style={styles.columnTitle}>Contact Us</h3>

          <div style={styles.contactList}>
            <a href="tel:+919876543210" style={styles.contactItem} className="cn-footer-link">
              <span style={styles.contactSymbol}>☎</span>
              <span>+91 98765 43210</span>
            </a>

            <a href="mailto:support@servicehub.com" style={styles.contactItem} className="cn-footer-link">
              <span style={styles.contactSymbol}>✉</span>
              <span>support@servicehub.com</span>
            </a>

            <Link to="/contact-us" style={styles.contactItem} className="cn-footer-link">
              <span style={styles.contactSymbol}>⌖</span>
              <span>123, 4th Cross, MG Road, Bangalore, Karnataka - 560001</span>
            </Link>
          </div>
        </div>
      </div>

      <style>{`
        .cn-footer-link:hover { color: #2E8B57 !important; }
        .cn-footer-social:hover { background: #2E8B57; border-color: #2E8B57; color: #ffffff; }
      `}</style>

      <div style={styles.bottomBar}>
        <p style={styles.copyText}>© 2024 ClickNido. All rights reserved.</p>

        <div style={styles.paymentWrap}>
          <span style={styles.paymentText}>VISA</span>
          <span style={styles.paymentText}>mastercard</span>
          <span style={styles.paymentText}>RuPay</span>
          <span style={styles.paymentText}>UPI</span>
          <span style={styles.paymentText}>100% SECURE PAYMENT</span>
        </div>
      </div>
    </footer>
  );
};

// Same palette as Header.js's compact pill nav — NAVY for text/headings,
// MINT (#2E8B57, "sea green") for the hover state.
const NAVY = "#152B5C";
const MINT = "#2E8B57";

const styles = {
  footer: {
    background: "#ffffff",
    color: NAVY,
    padding: "54px 32px 24px",
    fontFamily: "Arial, sans-serif",
    borderTop: "1px solid #e5e7eb"
  },
  topGrid: {
    display: "grid",
    gridTemplateColumns: "1.2fr 1fr 1fr 1fr 1fr 1.25fr",
    gap: "30px",
    alignItems: "start"
  },
  brandCol: {
    paddingRight: "10px"
  },
  brandWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    textDecoration: "none",
    marginBottom: "18px"
  },
  logoImg: {
    height: "48px",
    width: "auto",
    objectFit: "contain",
    display: "block"
  },
  brandDesc: {
    color: "rgba(21,43,92,0.75)",
    fontSize: "15px",
    lineHeight: "1.9",
    maxWidth: "250px",
    marginBottom: "24px"
  },
  socialWrap: {
    display: "flex",
    gap: "12px",
    marginBottom: "26px"
  },
  socialIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    border: `1px solid ${NAVY}33`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: NAVY,
    textDecoration: "none",
    transition: "all 0.25s ease",
    fontSize: "13px",
    fontWeight: "700",
    textTransform: "uppercase"
  },
  downloadCard: {
    border: "1px solid #e5e7eb",
    background: "#f8fafc",
    borderRadius: "14px",
    padding: "18px"
  },
  cardTitle: {
    margin: "0 0 8px",
    fontSize: "18px",
    fontWeight: "700",
    color: NAVY
  },
  cardText: {
    margin: "0 0 16px",
    color: "rgba(21,43,92,0.7)",
    fontSize: "14px"
  },
  appButtons: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap"
  },
  storeBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 14px",
    background: NAVY,
    border: `1px solid ${NAVY}`,
    color: "#fff",
    textDecoration: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600"
  },
  linkCol: {
    borderLeft: "1px solid #e5e7eb",
    paddingLeft: "24px"
  },
  contactCol: {
    borderLeft: "1px solid #e5e7eb",
    paddingLeft: "24px"
  },
  columnTitle: {
    margin: "0 0 20px",
    fontSize: "22px",
    fontWeight: "700",
    color: NAVY
  },
  linkList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  footerLink: {
    color: NAVY,
    textDecoration: "none",
    fontSize: "15px",
    transition: "all 0.25s ease"
  },
  contactList: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "26px"
  },
  contactItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    color: NAVY,
    textDecoration: "none",
    fontSize: "15px",
    lineHeight: "1.7"
  },
  contactSymbol: {
    minWidth: "16px",
    fontWeight: "700"
  },
  bottomBar: {
    marginTop: "42px",
    paddingTop: "22px",
    borderTop: "1px solid #e5e7eb",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px"
  },
  copyText: {
    margin: 0,
    color: "rgba(21,43,92,0.7)",
    fontSize: "14px"
  },
  paymentWrap: {
    display: "flex",
    alignItems: "center",
    gap: "22px",
    flexWrap: "wrap"
  },
  paymentText: {
    color: NAVY,
    fontWeight: "700",
    fontSize: "16px"
  }
};

export default Footer;